if (!customElements.get('adev-new-article')) {
    customElements.define('adev-new-article', class adevNewArticle extends HTMLElement {
        constructor() {
            super();

            this.tableOfContents = [];
        }

        initTableOfContents(){
            const contentEl = this.querySelector('[data-adev-new-article="content"]');
            const headings = contentEl.querySelectorAll('h2, h3, h4');
            headings.forEach(heading => {
                const id = heading.id || heading.textContent.trim().toLowerCase().replace(/\s+/g, '-');
                heading.id = id;
                this.tableOfContents.push({ id, title: heading.textContent });
            });

            const markup = this.querySelector('[data-adev-new-article="toc-item-markup"]').innerHTML;
            const listEl = this.querySelector('[data-adev-new-article="toc-list"]');
            
            this.tableOfContents.forEach(item => {
                const listItem = document.createElement('li');
                listItem.innerHTML = `${markup} <a href="#${item.id}">${item.title}</a>`;
                listEl.appendChild(listItem);
            });
        }

        connectedCallback() {
            this.initTableOfContents();
        }

        disconnectedCallback() {
            
        }

    });
}